"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _state = require("./state");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var _default = function _default(state, action) {
  _loglevel.default.debug('[AuthProvider] Action', action);

  switch (action.type) {
    case 'INITIALIZED':
      return _objectSpread(_objectSpread({}, state), {}, {
        isAuthenticated: !!action.token,
        token: action.token,
        user: action.user,
        isLoading: false,
        error: undefined
      });

    case 'GET_ACCESS_TOKEN_COMPLETE':
      return _objectSpread(_objectSpread({}, state), {}, {
        isAuthenticated: !!action.token,
        token: action.token
      });

    case 'GET_USER_PROFILE_COMPLETE':
      return _objectSpread(_objectSpread({}, state), {}, {
        user: action.user
      });

    case 'LOGOUT':
      return _objectSpread(_objectSpread({}, state), _state.initialAuthState);

    case 'ERROR':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        error: action.error
      });

    default:
      return state;
  }
};

exports.default = _default;